import moment from 'moment'
import BusinessPlanHome from '@/views/BusinessPlanHome'
import TasksPaginated from '@/components/TasksPaginated'
import { isNumber } from 'lodash'

export default [
  {
    name: 'tasks.today',
    path: '/business-plan/tasks/today/:userId?',
    component: TasksPaginated,
    props: route => ({
      title: `Today, ${moment().format('MMM D')}`,
      view: 'today',
      icon: 'fa-star',
      iconColorClass: 'text-flat-sunflower',
      hideNewTaskButton: true,
      userId: route.params.userId
    })
  },
  {
    name: 'tasks.upcoming',
    path: '/business-plan/tasks/upcoming/:userId?',
    component: TasksPaginated,
    props: route => ({
      title: 'Upcoming',
      view: 'upcoming',
      icon: 'fa-calendar',
      iconColorClass: 'text-flat-alizarin',
      hideNewTaskButton: true,
      userId: route.params.userId,
      groupByDay: true
    })
  },
  {
    name: 'tasks.anytime',
    path: '/business-plan/tasks/anytime/:userId?',
    component: TasksPaginated,
    props: route => ({
      title: 'Anytime',
      view: 'anytime',
      icon: 'fa-th-list',
      iconColorClass: 'text-flat-peter-river',
      hideNewTaskButton: true,
      userId: route.params.userId
    })
  },
  {
    name: 'tasks.complete',
    path: '/business-plan/tasks/complete/:userId?',
    component: TasksPaginated,
    props: route => ({
      title: 'Complete',
      view: 'complete',
      icon: 'fa fa-book',
      iconColorClass: 'text-flat-nephritis',
      hideNewTaskButton: true,
      userId: route.params.userId
    })
  },
  {
    name: 'tasks.search',
    path: '/business-plan/tasks/search/:userId?',
    component: TasksPaginated,
    props: route => ({
      title: 'Search',
      view: 'search',
      icon: 'fa fa-search',
      iconColorClass: 'text-muted',
      hideNewTaskButton: true,
      query: route.query.q,
      userId: route.params.userId
    })
  },
  {
    path: '/business-plan/tasks/:slug?',
    redirect (request) {
      let slug = request.params.slug
      if (!slug) {
        slug = 'today'
      } else if (isNumber(parseInt(slug))) {
        slug = 'today/' + slug
      }
      return '/business-plan/tasks/' + slug
    }
  },
  {
    path: '/business-plan/:userId/:focus',
    component: BusinessPlanHome,
    props: true
  }
]